export interface RouteMeta {
    title: string;
    eyebrow: string;
    description: string;
}

export const routesConfig: Record<string, RouteMeta> = {
    '/dashboard': { title: 'Visão geral', eyebrow: 'Painel operacional', description: 'Indicadores dos ativos da secretaria selecionada.' },
    '/reports': { title: 'Relatórios', eyebrow: 'Gestão e planejamento', description: 'Indicadores, inventários, históricos e previsão estatística de reposição.' },
    '/ranking': { title: 'Ranking de computadores', eyebrow: 'Desempenho técnico', description: 'Comparação de capacidade e prioridade de renovação.' },
    '/asset-composer': { title: 'Equipamentos', eyebrow: 'Patrimônio e inventário', description: 'Cadastro e localização dos equipamentos municipais.' },
    '/core-stock-manager': { title: 'Estoque central', eyebrow: 'Materiais e componentes', description: 'Controle das peças e dos suprimentos disponíveis.' },
    '/stock-outflow': { title: 'Saída de materiais', eyebrow: 'Distribuição e entrega', description: 'Remessas do estoque para unidades e setores.' },
    '/tickets': { title: 'Chamados', eyebrow: 'Central de atendimento', description: 'Consulta e acompanhamento dos atendimentos de TI.' },
    '/tickets/new': { title: 'Novo chamado', eyebrow: 'Central de atendimento', description: 'Registro assistido de solicitações e ocorrências de TI.' },
    '/applicants': { title: 'Solicitantes', eyebrow: 'Servidores municipais', description: 'Pessoas autorizadas a solicitar atendimento.' },
    '/organization': { title: 'Equipe/Organização', eyebrow: 'Cadastros', description: 'Equipes de TI, secretarias, unidades e locais.' },
    '/external-repairs/companies': { title: 'Empresas terceirizadas', eyebrow: 'Manutenção externa', description: 'Empresas que recebem equipamentos para manutenção.' },
    '/system-settings': { title: 'Configurações', eyebrow: 'Cadastros estruturais', description: 'Parâmetros compartilhados do sistema.' },
    '/external-repairs': { title: 'Manutenção externa', eyebrow: 'Equipamentos e assistência', description: 'Envio, acompanhamento e retorno de equipamentos em empresas terceirizadas.' },
    '/it-teams': { title: 'Equipes de TI', eyebrow: 'Administração', description: 'Usuários, técnicos e secretarias atendidas por cada equipe.' },
    '/inventory-centers': { title: 'Centrais de estoque', eyebrow: 'Administração', description: 'Centrais das equipes e secretarias atendidas.' },
    '/users': { title: 'Usuários', eyebrow: 'Administração', description: 'Contas de acesso e vínculos com uma ou mais equipes de informática.' },
    '/profile': { title: 'Meu perfil', eyebrow: 'Conta e acesso', description: 'Dados da conta e do contexto de trabalho atual.' },
};

/** Resolve também páginas dinâmicas, como /tickets/{id}. */
export const resolveRouteMeta = (pathname: string): RouteMeta => {
    if (/^\/tickets\/[^/]+\/progress$/.test(pathname)) {
        return {
            title: 'Atender chamado',
            eyebrow: 'Central de atendimento',
            description: 'Registre o serviço, as peças utilizadas, o responsável e a situação atual.',
        };
    }
    if (/^\/tickets\/[^/]+$/.test(pathname) && pathname !== '/tickets/new') {
        return {
            title: 'Visualizar chamado',
            eyebrow: 'Central de atendimento',
            description: 'Dados completos, histórico, anexos e documento do protocolo.',
        };
    }
    if (/^\/tickets\/[^/]+\/edit$/.test(pathname)) return {title:'Editar chamado',eyebrow:'Central de atendimento',description:'Corrija os dados do chamado com rastreabilidade no histórico.'};
    const match=pathname.match(/^(.*)\/(new|[^/]+\/edit)$/);
    if(match && routesConfig[match[1]]) return {...routesConfig[match[1]],title:`${pathname.endsWith('/new')?'Novo cadastro':'Editar cadastro'} · ${routesConfig[match[1]].title}`};
    return routesConfig[pathname] || {
        title: 'Sistema',
        eyebrow: 'Gestão municipal de TI',
        description: 'Ambiente administrativo.',
    };
};
